export type SourceReadinessKey = 'title' | 'author' | 'blurb' | 'genres' | 'keywords' | 'cover';

export type SourceReadinessInput = Record<`has${Capitalize<SourceReadinessKey>}`, boolean>;

export type SourceReadinessItem = {
  key: SourceReadinessKey;
  label: string;
  done: boolean;
  targetId: string;
  actionLabel: string;
  focusSelector?: string;
};

const SOURCE_READINESS_CONFIG: Array<Omit<SourceReadinessItem, 'done'>> = [
  {
    key: 'title',
    label: 'Title',
    targetId: 'metadata-identity',
    actionLabel: 'Add title',
    focusSelector: '[data-testid="tutorial:metadata:title-input"]',
  },
  {
    key: 'author',
    label: 'Author',
    targetId: 'metadata-identity',
    actionLabel: 'Add author',
    focusSelector: '[data-testid="tutorial:metadata:author-input"]',
  },
  {
    key: 'blurb',
    label: 'Blurb',
    targetId: 'metadata-blurb',
    actionLabel: 'Write blurb',
    focusSelector: '.metadata-blurb-editor .ql-editor',
  },
  {
    key: 'genres',
    label: 'Genres',
    targetId: 'metadata-positioning',
    actionLabel: 'Add genres',
    focusSelector: '[data-testid="tutorial:metadata:genres-select"] .ant-select-selection-search-input',
  },
  {
    key: 'keywords',
    label: 'Keywords',
    targetId: 'metadata-lists',
    actionLabel: 'Add keywords',
    focusSelector: '[data-testid="tutorial:metadata:keywords-select"] .ant-select-selection-search-input',
  },
  {
    key: 'cover',
    label: 'Cover',
    targetId: 'metadata-cover',
    actionLabel: 'Add cover',
    focusSelector: '#metadata-cover button, #metadata-cover [role="button"]',
  },
];

const NEXT_ACTION_PRIORITY: SourceReadinessKey[] = ['title', 'author', 'cover', 'blurb', 'genres', 'keywords'];

const readinessInputKeyBySourceKey: Record<SourceReadinessKey, keyof SourceReadinessInput> = {
  title: 'hasTitle',
  author: 'hasAuthor',
  blurb: 'hasBlurb',
  genres: 'hasGenres',
  keywords: 'hasKeywords',
  cover: 'hasCover',
};

export const buildSourceReadinessItems = (input: SourceReadinessInput): SourceReadinessItem[] =>
  SOURCE_READINESS_CONFIG.map(item => ({
    ...item,
    done: Boolean(input[readinessInputKeyBySourceKey[item.key]]),
  }));

export const getSourceMetadataNextActionItem = (
  items: SourceReadinessItem[],
): SourceReadinessItem | null => {
  for (const key of NEXT_ACTION_PRIORITY) {
    const item = items.find(readinessItem => readinessItem.key === key);
    if (item && !item.done) {
      return item;
    }
  }
  return null;
};
